import { createGlobalStyle } from "styled-components";

export const BloctoIframeGlobalStyle = createGlobalStyle`
  iframe {
    &[src*="blocto"] {
      z-index: 2055 !important;
    }
  }
`;
